import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { Option_Entity } from "../../entities/option";
import { autopilotApi } from "../api/autopilotApi";

const optionsAdapter = createEntityAdapter<Option_Entity>();
const initialState = optionsAdapter.getInitialState();

export const optionEndpoints = autopilotApi.injectEndpoints({
  endpoints: (build) => ({
    getOptions: build.query<EntityState<Option_Entity>, void>({
      query: () => `options`,
      transformResponse: (responseData: Option_Entity[]) => {
        return optionsAdapter.setAll(initialState, responseData);
      },
      providesTags: ["options"],
    }),
    getOption: build.query<Option_Entity, number>({
      query: (id) => `options/${id}`,
      providesTags: (result, error, id) => [{ type: "options", id }],
    }),
    createOption: build.mutation<Option_Entity, Partial<Option_Entity>>({
      query: (body) => ({
        method: "POST",
        body,
        url: `options`,
      }),
      invalidatesTags: ["options"],
    }),
    updateOption: build.mutation<
      void,
      { id: number; body: Partial<Option_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `options/${args.id}`,
      }),
      invalidatesTags: ["options"],
    }),
    deleteOption: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `options/${id}`,
      }),
      invalidatesTags: ["options"],
    }),
  }),
});

export const {
  useGetOptionQuery,
  useGetOptionsQuery,
  useCreateOptionMutation,
  useDeleteOptionMutation,
  useUpdateOptionMutation,
} = optionEndpoints;
